const CheckMarkIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M8.99989 15.5858L19.2933 5.29248L20.7066 6.70761L8.99989 18.4142L3.29321 12.7076L4.7065 11.2924L8.99989 15.5858Z" fill="#F83D11" />
  </svg>
);

export default CheckMarkIcon;
